import { createAsyncThunk } from '@reduxjs/toolkit';
import { batch } from 'react-redux';

import { authSet } from '../../../utils/request';
import { METHOD_PATCH } from '../../../constants/api';
import { setCoOrders } from '../../../actions/coilovers/orders/patchCoOrders';
import actionCoOrder from './actionCoOrder';
import orderActionTypes from '../../../constants/orderActionTypes';
import coOrderStatus from '../../../constants/coOrderStatus';

const patchCoOrder = createAsyncThunk('coOrders/patchCoOrder',
  async ({ _id, formData }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authSet(METHOD_PATCH, `/co/orders/${_id}`, formData);
      batch(() => {
        dispatch(setCoOrders(data));
        if (
          formData.order_status === coOrderStatus.OUT_OF_RESERVE
          || formData.order_status === coOrderStatus.OUT_OF_RESERVE
        ) {
          dispatch(actionCoOrder({
            id: _id,
            type: orderActionTypes.CHECK_AVAILABILITY
          }));
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchCoOrder;
